import axiosInstance from "../helpers/axiosInstance";


export const fetchWarehouses = async (params = {}) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses`, { params })
    return res.data
}

export const fetchWarehousesOpen = async () => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses_open`)
    return res.data
}

export const fetchWarehouse = async (id, params = {}) => {
    if(id==null)
        return null
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${id}`, {params})
    return res.data
}

export const fetchWarehouseShippingMethods = async (id = {}, params = {}) => {
    if(id==null)
        return null
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${id}/shipping-methods`, {params})
    return res.data
}

export const normalizeWarehouseShippingMethodsResponse = (responseData) => {
    if (Array.isArray(responseData)) {
        return responseData
    }
    if (Array.isArray(responseData?.shipping_methods)) {
        return responseData.shipping_methods
    }
    if (Array.isArray(responseData?.data)) {
        return responseData.data
    }
    return []
}

export const fetchWarehouseShippingMethodsList = async (id = {}, params = {}) => {
    const responseData = await fetchWarehouseShippingMethods(id, params)
    return normalizeWarehouseShippingMethodsResponse(responseData)
}

export const fetchWarehouseVolumeCategories = async (warehouseId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/volume-categories`)
    return res.data
}


export const fetchReturnsSummary = async (warehouseId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/returns-summary`)
    return res.data
}

export const fetchDispatchSchedule = async (warehouseId) => {
    let params = {
        carrier_name: "UBER",
        window_processing_time: 90
    }
    console.log(params)
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/dispatch-schedules`, {params})
    return res.data
}

